import React, { Fragment, useEffect, useState } from "react";
import "../../../styles/group.scss";
import { useNavigate, useParams } from "react-router-dom";
import image from "../../../assets/image.png";
import axios from "axios";
import { isAuth } from "../../auth/ProtectedRoute";
import { ProjectData } from "./Types/DataType";
import { ActivityLogValues } from "../ActivityLog/types/DataType";
import swal from "sweetalert";
import useModal from "../../../components/modal/useModal";
import { CircularProgress } from "@mui/material";
import RejectProjectModal from "./components/RejectProjectModal";
import moment from "moment";
import FileName from "./components/FileName";
import BiddingDisplay from "./components/BiddingDisplay";
import PendingTransaction from "./components/PendingTransaction";
const ViewProject = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [project, setProject] = useState<ProjectData>({} as ProjectData);
  const [loading, setLoading] = useState<boolean>(false);
  const { isOpen, toggle } = useModal();

  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `project/${params.id}`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res?.data?.response === true) {
          setProject(res?.data?.data);
        }
        
      })
      .catch((err) => {
        console.error(err);
        swal({
          icon: "error",
          text: "Something went wrong. Please try again later!",
        });
      });
  }, []);

  const getAttachFilename = (mediaString: any) => {
    const ext = mediaString?.split(".").pop();
    const tag = mediaString?.split("_");
    const name = tag?.slice(2, tag.length).join("_");
    return name?.slice(0, 10) + "." + ext;
  };
  //console.log("Project:", project)

  return (
    <Fragment>
      <div className="feed-view">
        {/* HEADER */}
        <div className="feed-view--heading">
          <div className="feed-view--heading--title">
            <h1>Project View</h1>
          </div>
          <div className="feed-view--heading-btn">
            <button onClick={() => navigate(-1)}>
              <span>
                <svg
                  width="22"
                  height="20"
                  viewBox="0 0 22 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 2L2 7L7 12"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M2 7H10C15.523 7 20 11.477 20 17V18"
                    stroke="white"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              Back
            </button>
          </div>
        </div>

        <div className="project-body">
          {/* DETAIL GRID */}
          <div className="project-body--detail">
            <div className="project-body--detail-header">
              {/* TITLE AREA */}
              <div className="title">
                <div className="title-area">
                  <h2>
                    {project?.title?.length > 25
                      ? `${project?.title?.slice(0, 25)}...`
                      : project?.title}{" "}
                  </h2>
                  <div className="title-area-post">
                    <h5> - Created</h5>
                    <p>
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect width="24" height="24" rx="12" fill="#F1F1F1" />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.1096 5.77778C10.1096 5.34822 9.7784 5 9.36986 5C8.96132 5 8.63014 5.34822 8.63014 5.77778V6.38272H7.72603C6.77277 6.38272 6 7.19524 6 8.19753V11.3086V17.1852C6 18.1875 6.77277 19 7.72603 19H16.274C17.2272 19 18 18.1875 18 17.1852V11.3086V8.19753C18 7.19524 17.2272 6.38272 16.274 6.38272H15.3699V5.77778C15.3699 5.34822 15.0387 5 14.6301 5C14.2216 5 13.8904 5.34822 13.8904 5.77778V6.38272H10.1096V5.77778ZM16.5205 10.5309V8.19753C16.5205 8.05435 16.4102 7.93827 16.274 7.93827H15.3699V8.54321C15.3699 8.97276 15.0387 9.32099 14.6301 9.32099C14.2216 9.32099 13.8904 8.97276 13.8904 8.54321V7.93827H10.1096V8.54321C10.1096 8.97276 9.7784 9.32099 9.36986 9.32099C8.96132 9.32099 8.63014 8.97276 8.63014 8.54321V7.93827H7.72603C7.58985 7.93827 7.47945 8.05435 7.47945 8.19753V10.5309H16.5205ZM7.47945 12.0864H16.5205V17.1852C16.5205 17.3284 16.4102 17.4444 16.274 17.4444H7.72603C7.58985 17.4444 7.47945 17.3284 7.47945 17.1852V12.0864Z"
                            fill="#565656"
                          />
                        </svg>
                      </span>
                      {moment(project.created_at).fromNow()}
                      {/* {project?.created_at} */}
                      {/* prop needs to be added to response object */}
                    </p>
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                {project?.status === 1 ? (
                  <div className="title-buttons">
                    <button className="reject" onClick={toggle}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.26512 4.79771C5.85472 4.39371 5.19691 4.40192 4.79588 4.81605C4.39484 5.23018 4.40244 5.89341 4.81284 6.29741L10.6058 12L4.81284 17.7026C4.40244 18.1066 4.39484 18.7698 4.79588 19.184C5.19691 19.5981 5.85472 19.6063 6.26512 19.2023L12.0937 13.4647L17.7349 19.0179C18.1453 19.4219 18.8031 19.4137 19.2041 18.9995C19.6052 18.5854 19.5976 17.9222 19.1872 17.5182L13.5815 12L19.1872 6.48182C19.5976 6.07782 19.6052 5.41459 19.2041 5.00046C18.8031 4.58633 18.1453 4.57812 17.7349 4.98213L12.0937 10.5353L6.26512 4.79771Z"
                          fill="#DB2128"
                        />
                      </svg>
                      Reject
                    </button>
                    <button
                      className="accept"
                      onClick={() => {
                        setLoading(true)
                        axios({
                          method: "POST",
                          url: process.env.REACT_APP_HOST_API + `project/approve/${params.id}`,
                          headers: {
                            Authorization: `Bearer ${isAuth()}`,
                          },
                        })
                          .then(res => {
                            if (res?.data?.response === true) {
                              setLoading(false)
                              swal({
                                icon: "success",
                                text: res?.data?.message,
                              })
                              let activityLogItem
                              if (typeof window !== "undefined") {
                                if (sessionStorage.getItem("activityDetail")) {
                                  activityLogItem = JSON.parse(
                                    sessionStorage.getItem("activityDetail")!
                                  )
                                }
                              }
                              const activityDetail: ActivityLogValues = {
                                full_name: activityLogItem.full_name,
                                role: activityLogItem.role,
                                ip_address: activityLogItem.ip_address,
                                browser: activityLogItem.browser,
                                events: `Approved Project: ${project?.title}`,
                                module: "Task Management",
                                location: activityLogItem.location,
                                email: activityLogItem.email,
                              }
                              axios({
                                method: "POST",
                                url: process.env.REACT_APP_HOST_API + "manage-activity/user",
                                headers: {
                                  Authorization: `Bearer ${isAuth()}`,
                                },
                                data: activityDetail,
                              }).then(() => {
                                history.go(0)
                              })
                            }
                          })
                          .catch(err => {
                            setLoading(false)
                            console.error(err)
                            swal({
                              icon: "error",
                              text: "Something went wrong. Please try again later!",
                            })
                          })
                      }}
                    >
                      {loading ? (
                        <CircularProgress sx={{ color: "white" }} size={25} />
                      ) : (
                        "Approve Request"
                      )}
                    </button>
                  </div>
                ) : project?.status === 2 ? (
                  <div className="title-buttons">
                    <button className="accept-button">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="fi_9450893">
                          <g id="Icon">
                            <path
                              id="Vector"
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.96975 12.5271C7.67675 12.2351 7.67675 11.7591 7.96975 11.4671C8.26175 11.1741 8.73775 11.1741 9.02975 11.4671L10.8328 13.2701L14.9698 9.13306C15.2618 8.84106 15.7378 8.84106 16.0298 9.13306C16.3228 9.42606 16.3228 9.90106 16.0298 10.1941L11.3638 14.8611C11.0708 15.1541 10.5958 15.1541 10.3028 14.8611L7.96975 12.5271Z"
                              fill="#32C769"
                            />
                            <path
                              id="Vector_2"
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.7312 1.775C11.0672 1.439 11.5232 1.25 11.9992 1.25C12.4752 1.25 12.9312 1.439 13.2672 1.775L14.7122 3.22C14.7782 3.286 14.8722 3.317 14.9652 3.302L16.9832 2.983C17.4532 2.908 17.9332 3.024 18.3182 3.303C18.7022 3.583 18.9602 4.004 19.0352 4.473L19.3542 6.491C19.3692 6.584 19.4272 6.664 19.5112 6.707L21.3312 7.634C21.7552 7.85 22.0762 8.226 22.2232 8.678C22.3702 9.13 22.3312 9.623 22.1152 10.046L21.1882 11.867C21.1452 11.951 21.1452 12.049 21.1882 12.133L22.1152 13.954C22.3312 14.377 22.3702 14.87 22.2232 15.322C22.0762 15.774 21.7552 16.15 21.3312 16.366L19.5112 17.293C19.4272 17.336 19.3692 17.416 19.3542 17.509L19.0352 19.527C18.9602 19.996 18.7022 20.417 18.3182 20.697C17.9332 20.976 17.4532 21.092 16.9832 21.017L14.9652 20.698C14.8722 20.683 14.7782 20.714 14.7122 20.78L13.2672 22.225C12.9312 22.561 12.4752 22.75 11.9992 22.75C11.5232 22.75 11.0672 22.561 10.7312 22.225L9.2862 20.78C9.2202 20.714 9.1262 20.683 9.0332 20.698L7.0152 21.017C6.5452 21.092 6.0652 20.976 5.6802 20.697C5.2962 20.417 5.0382 19.996 4.9632 19.527L4.6442 17.509C4.6292 17.416 4.5712 17.336 4.4872 17.293L2.6672 16.366C2.2432 16.15 1.9222 15.774 1.7752 15.322C1.6282 14.87 1.6672 14.377 1.8832 13.954L2.8102 12.133C2.8532 12.049 2.8532 11.951 2.8102 11.867L1.8832 10.046C1.6672 9.623 1.6282 9.13 1.7752 8.678C1.9222 8.226 2.2432 7.85 2.6672 7.634L4.4872 6.707C4.5712 6.664 4.6292 6.584 4.6442 6.491L4.9632 4.473C5.0382 4.004 5.2962 3.583 5.6802 3.303C6.0652 3.024 6.5452 2.908 7.0152 2.983L9.0332 3.302C9.1262 3.317 9.2202 3.286 9.2862 3.22L10.7312 1.775ZM11.7922 2.836L10.3472 4.281C9.9412 4.687 9.3652 4.874 8.7982 4.784L6.7802 4.464C6.7032 4.452 6.6252 4.471 6.5622 4.517C6.4992 4.562 6.4572 4.631 6.4452 4.708L6.1252 6.726C6.0352 7.293 5.6802 7.783 5.1682 8.043L3.3472 8.971C3.2782 9.006 3.2262 9.068 3.2022 9.142C3.1782 9.216 3.1842 9.296 3.2192 9.365L4.1472 11.186C4.4082 11.697 4.4082 12.303 4.1472 12.814L3.2192 14.635C3.1842 14.704 3.1782 14.784 3.2022 14.858C3.2262 14.932 3.2782 14.994 3.3472 15.029L5.1682 15.957C5.6802 16.217 6.0352 16.707 6.1252 17.274L6.4452 19.292C6.4572 19.369 6.4992 19.438 6.5622 19.483C6.6252 19.529 6.7032 19.548 6.7802 19.536L8.7982 19.216C9.3652 19.126 9.9412 19.313 10.3472 19.719L11.7922 21.164C11.8472 21.219 11.9212 21.25 11.9992 21.25C12.0772 21.25 12.1512 21.219 12.2062 21.164L13.6512 19.719C14.0572 19.313 14.6332 19.126 15.2002 19.216L17.2182 19.536C17.2952 19.548 17.3732 19.529 17.4362 19.483C17.4992 19.438 17.5412 19.369 17.5532 19.292L17.8732 17.274C17.9632 16.707 18.3182 16.217 18.8302 15.957L20.6512 15.029C20.7202 14.994 20.7722 14.932 20.7962 14.858C20.8202 14.784 20.8142 14.704 20.7792 14.635L19.8512 12.814C19.5902 12.303 19.5902 11.697 19.8512 11.186L20.7792 9.365C20.8142 9.296 20.8202 9.216 20.7962 9.142C20.7722 9.068 20.7202 9.006 20.6512 8.971L18.8302 8.043C18.3182 7.783 17.9632 7.293 17.8732 6.726L17.5532 4.708C17.5412 4.631 17.4992 4.562 17.4362 4.517C17.3732 4.471 17.2952 4.452 17.2182 4.464L15.2002 4.784C14.6332 4.874 14.0572 4.687 13.6512 4.281L12.2062 2.836C12.1512 2.781 12.0772 2.75 11.9992 2.75C11.9212 2.75 11.8472 2.781 11.7922 2.836Z"
                              fill="#32C769"
                            />
                          </g>
                        </g>
                      </svg>
                      Approved
                    </button>
                  </div>
                ) : (
                  <div className="title-buttons">
                    <button className="reject-button">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="fi_9450893">
                          <g id="Icon">
                            <g id="Group">
                              <path
                                id="Vector"
                                d="M15.0122 13.9939L10.1764 9.15817C9.96552 8.94728 9.6236 8.94728 9.41303 9.15817L9.15817 9.41264C8.94728 9.6236 8.94728 9.96552 9.15817 10.1761L13.9939 15.0118C14.2049 15.2227 14.5468 15.2227 14.7574 15.0118L15.0118 14.7574C15.2231 14.5468 15.2231 14.2048 15.0122 13.9939Z"
                                fill="#F44336"
                              />
                              <path
                                id="Vector_2"
                                d="M13.9939 9.15813L9.15817 13.9939C8.94728 14.2048 8.94728 14.5467 9.15817 14.7573L9.41264 15.0118C9.6236 15.2227 9.96552 15.2227 10.1761 15.0118L15.0122 10.1764C15.2231 9.96548 15.2231 9.62355 15.0122 9.41298L14.7577 9.15852C14.5468 8.94723 14.2049 8.94723 13.9939 9.15813Z"
                                fill="#F44336"
                              />
                            </g>
                            <path
                              id="Vector_3"
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M10.7312 1.775C11.0672 1.439 11.5232 1.25 11.9992 1.25C12.4752 1.25 12.9312 1.439 13.2672 1.775L14.7122 3.22C14.7782 3.286 14.8722 3.317 14.9652 3.302L16.9832 2.983C17.4532 2.908 17.9332 3.024 18.3182 3.303C18.7022 3.583 18.9602 4.004 19.0352 4.473L19.3542 6.491C19.3692 6.584 19.4272 6.664 19.5112 6.707L21.3312 7.634C21.7552 7.85 22.0762 8.226 22.2232 8.678C22.3702 9.13 22.3312 9.623 22.1152 10.046L21.1882 11.867C21.1452 11.951 21.1452 12.049 21.1882 12.133L22.1152 13.954C22.3312 14.377 22.3702 14.87 22.2232 15.322C22.0762 15.774 21.7552 16.15 21.3312 16.366L19.5112 17.293C19.4272 17.336 19.3692 17.416 19.3542 17.509L19.0352 19.527C18.9602 19.996 18.7022 20.417 18.3182 20.697C17.9332 20.976 17.4532 21.092 16.9832 21.017L14.9652 20.698C14.8722 20.683 14.7782 20.714 14.7122 20.78L13.2672 22.225C12.9312 22.561 12.4752 22.75 11.9992 22.75C11.5232 22.75 11.0672 22.561 10.7312 22.225L9.2862 20.78C9.2202 20.714 9.1262 20.683 9.0332 20.698L7.0152 21.017C6.5452 21.092 6.0652 20.976 5.6802 20.697C5.2962 20.417 5.0382 19.996 4.9632 19.527L4.6442 17.509C4.6292 17.416 4.5712 17.336 4.4872 17.293L2.6672 16.366C2.2432 16.15 1.9222 15.774 1.7752 15.322C1.6282 14.87 1.6672 14.377 1.8832 13.954L2.8102 12.133C2.8532 12.049 2.8532 11.951 2.8102 11.867L1.8832 10.046C1.6672 9.623 1.6282 9.13 1.7752 8.678C1.9222 8.226 2.2432 7.85 2.6672 7.634L4.4872 6.707C4.5712 6.664 4.6292 6.584 4.6442 6.491L4.9632 4.473C5.0382 4.004 5.2962 3.583 5.6802 3.303C6.0652 3.024 6.5452 2.908 7.0152 2.983L9.0332 3.302C9.1262 3.317 9.2202 3.286 9.2862 3.22L10.7312 1.775ZM11.7922 2.836L10.3472 4.281C9.9412 4.687 9.3652 4.874 8.7982 4.784L6.7802 4.464C6.7032 4.452 6.6252 4.471 6.5622 4.517C6.4992 4.562 6.4572 4.631 6.4452 4.708L6.1252 6.726C6.0352 7.293 5.6802 7.783 5.1682 8.043L3.3472 8.971C3.2782 9.006 3.2262 9.068 3.2022 9.142C3.1782 9.216 3.1842 9.296 3.2192 9.365L4.1472 11.186C4.4082 11.697 4.4082 12.303 4.1472 12.814L3.2192 14.635C3.1842 14.704 3.1782 14.784 3.2022 14.858C3.2262 14.932 3.2782 14.994 3.3472 15.029L5.1682 15.957C5.6802 16.217 6.0352 16.707 6.1252 17.274L6.4452 19.292C6.4572 19.369 6.4992 19.438 6.5622 19.483C6.6252 19.529 6.7032 19.548 6.7802 19.536L8.7982 19.216C9.3652 19.126 9.9412 19.313 10.3472 19.719L11.7922 21.164C11.8472 21.219 11.9212 21.25 11.9992 21.25C12.0772 21.25 12.1512 21.219 12.2062 21.164L13.6512 19.719C14.0572 19.313 14.6332 19.126 15.2002 19.216L17.2182 19.536C17.2952 19.548 17.3732 19.529 17.4362 19.483C17.4992 19.438 17.5412 19.369 17.5532 19.292L17.8732 17.274C17.9632 16.707 18.3182 16.217 18.8302 15.957L20.6512 15.029C20.7202 14.994 20.7722 14.932 20.7962 14.858C20.8202 14.784 20.8142 14.704 20.7792 14.635L19.8512 12.814C19.5902 12.303 19.5902 11.697 19.8512 11.186L20.7792 9.365C20.8142 9.296 20.8202 9.216 20.7962 9.142C20.7722 9.068 20.7202 9.006 20.6512 8.971L18.8302 8.043C18.3182 7.783 17.9632 7.293 17.8732 6.726L17.5532 4.708C17.5412 4.631 17.4992 4.562 17.4362 4.517C17.3732 4.471 17.2952 4.452 17.2182 4.464L15.2002 4.784C14.6332 4.874 14.0572 4.687 13.6512 4.281L12.2062 2.836C12.1512 2.781 12.0772 2.75 11.9992 2.75C11.9212 2.75 11.8472 2.781 11.7922 2.836Z"
                              fill="#DB2128"
                            />
                          </g>
                        </g>
                      </svg>
                      Rejected
                    </button>
                  </div>
                )}
              </div>

              {/* SUBTITLE AREA */}
              <div className="subtitle">
                <div className="subtitle-location">
                  <h5>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Icon pack Variants">
                        <path
                          id="Union"
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M5.20955 3.79668C5.96112 2.97706 6.96641 2.52986 8 2.52986C9.03359 2.52986 10.0389 2.97706 10.7905 3.79668C11.544 4.61842 11.9769 5.74544 11.9769 6.93245C11.9769 7.32437 11.8503 7.82725 11.595 8.42058C11.3435 9.00541 10.988 9.63024 10.581 10.2523C9.76699 11.4966 8.78613 12.6706 8.13669 13.4048C8.09457 13.4524 8.04554 13.4701 8 13.4701C7.95446 13.4701 7.90543 13.4524 7.86331 13.4048C7.21387 12.6706 6.23301 11.4966 5.41897 10.2523C5.012 9.63024 4.65655 9.00541 4.40497 8.42058C4.14974 7.82725 4.02308 7.32437 4.02308 6.93245C4.02308 5.74544 4.45604 4.61842 5.20955 3.79668ZM8 1C6.52016 1 5.11496 1.64166 4.08926 2.76024C3.06549 3.8767 2.5 5.37844 2.5 6.93245C2.5 7.61999 2.71232 8.34277 3.00683 9.02739C3.305 9.72052 3.71005 10.4259 4.14612 11.0925C5.01817 12.4254 6.05354 13.6622 6.72473 14.4209C7.4077 15.193 8.5923 15.193 9.27527 14.4209C9.94646 13.6622 10.9818 12.4254 11.8539 11.0925C12.2899 10.4259 12.695 9.72052 12.9932 9.02739C13.2877 8.34277 13.5 7.61999 13.5 6.93245C13.5 5.37844 12.9345 3.8767 11.9107 2.76024C10.885 1.64166 9.47984 1 8 1ZM7.40769 7.20443C7.40769 6.87585 7.67288 6.60948 8 6.60948C8.32712 6.60948 8.59231 6.87585 8.59231 7.20443C8.59231 7.53301 8.32712 7.79937 8 7.79937C7.67288 7.79937 7.40769 7.53301 7.40769 7.20443ZM8 5.07962C6.8317 5.07962 5.88461 6.03093 5.88461 7.20443C5.88461 8.37793 6.8317 9.32923 8 9.32923C9.16829 9.32923 10.1154 8.37793 10.1154 7.20443C10.1154 6.03093 9.16829 5.07962 8 5.07962Z"
                          fill="#ED2121"
                        />
                      </g>
                    </svg>
                    {project?.preferred_location?.name}
                  </h5>
                  <p>Preferred Location</p>
                </div>
                <div className="subtitle-duration">
                  <h5>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="24" height="24" rx="12" fill="#95AAF5" fillOpacity="0.3" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M10.1096 5.77778C10.1096 5.34822 9.7784 5 9.36986 5C8.96132 5 8.63014 5.34822 8.63014 5.77778V6.38272H7.72603C6.77277 6.38272 6 7.19524 6 8.19753V11.3086V17.1852C6 18.1875 6.77277 19 7.72603 19H16.274C17.2272 19 18 18.1875 18 17.1852V11.3086V8.19753C18 7.19524 17.2272 6.38272 16.274 6.38272H15.3699V5.77778C15.3699 5.34822 15.0387 5 14.6301 5C14.2216 5 13.8904 5.34822 13.8904 5.77778V6.38272H10.1096V5.77778ZM16.5205 10.5309V8.19753C16.5205 8.05435 16.4102 7.93827 16.274 7.93827H15.3699V8.54321C15.3699 8.97276 15.0387 9.32099 14.6301 9.32099C14.2216 9.32099 13.8904 8.97276 13.8904 8.54321V7.93827H10.1096V8.54321C10.1096 8.97276 9.7784 9.32099 9.36986 9.32099C8.96132 9.32099 8.63014 8.97276 8.63014 8.54321V7.93827H7.72603C7.58985 7.93827 7.47945 8.05435 7.47945 8.19753V10.5309H16.5205ZM7.47945 12.0864H16.5205V17.1852C16.5205 17.3284 16.4102 17.4444 16.274 17.4444H7.72603C7.58985 17.4444 7.47945 17.3284 7.47945 17.1852V12.0864Z"
                        fill="#4264DF"
                      />
                    </svg>
                    {project?.duration}
                  </h5>
                  <p>Expected Duration</p>
                </div>
                <div className="subtitle-experience">
                  <h5>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="24" height="24" rx="12" fill="#F9DDB9" fillOpacity="0.3" />
                      <path
                        d="M11.4445 6.37979C11.6365 5.8734 12.3631 5.8734 12.5556 6.37979L13.7976 9.82014C13.8846 10.0481 14.106 10.1999 14.3532 10.1999H17.4052C17.9692 10.1999 18.2152 10.9019 17.7718 11.2457L15.5999 13.1999C15.5026 13.2747 15.4315 13.3784 15.3968 13.4961C15.3621 13.6138 15.3656 13.7395 15.4067 13.8551L16.1999 17.2168C16.3931 17.7568 15.7679 18.2206 15.2951 17.8882L12.3451 16.0162C12.244 15.9452 12.1236 15.9071 12.0001 15.9071C11.8766 15.9071 11.7561 15.9452 11.6551 16.0162L8.70502 17.8882C8.23284 18.2206 7.60707 17.7562 7.80026 17.2168L8.59342 13.8551C8.63457 13.7395 8.63804 13.6138 8.60333 13.4961C8.56862 13.3784 8.49752 13.2747 8.40023 13.1999L6.22833 11.2457C5.78435 10.9019 6.03154 10.1999 6.59431 10.1999H9.64638C9.76655 10.2003 9.88401 10.1642 9.98321 10.0964C10.0824 10.0286 10.1587 9.93226 10.202 9.82014L11.4439 6.37979H11.4445Z"
                        stroke="#EFA148"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    {project?.experience}
                  </h5>
                  <p>Experience Level</p>
                </div>
                <div className="subtitle-budject">
                  <h5>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect width="24" height="24" rx="12" fill="#E2F3ED" />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.55556 12C6.55556 8.99312 8.99312 6.55556 12 6.55556C15.0069 6.55556 17.4444 8.99312 17.4444 12C17.4444 15.0069 15.0069 17.4444 12 17.4444C8.99312 17.4444 6.55556 15.0069 6.55556 12ZM12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5ZM12.8765 8.47404C12.8765 8.04449 12.5283 7.69627 12.0987 7.69627C11.6691 7.69627 11.3209 8.04449 11.3209 8.47404V8.99881H10.8691C10.2748 8.99881 9.79027 9.25927 9.47691 9.67043C9.18175 10.0577 9.07 10.533 9.07954 10.9628C9.0891 11.3933 9.22156 11.8544 9.51053 12.2264C9.81371 12.6166 10.282 12.8923 10.8691 12.8923H13.111C13.3406 12.8923 13.4184 12.9653 13.4426 12.9928C13.4772 13.0323 13.5109 13.1078 13.5018 13.2201C13.4926 13.3319 13.4422 13.4443 13.3571 13.526C13.2807 13.5994 13.149 13.6746 12.9188 13.6746H10.0284C9.59882 13.6746 9.25059 14.0228 9.25059 14.4524C9.25059 14.8819 9.59882 15.2302 10.0284 15.2302H11.3209V15.6217C11.3209 16.0513 11.6691 16.3995 12.0987 16.3995C12.5283 16.3995 12.8765 16.0513 12.8765 15.6217V15.2302H12.9188C14.1941 15.2302 14.9738 14.306 15.0521 13.3468C15.0907 12.8746 14.9618 12.3656 14.6118 11.9668C14.2512 11.556 13.7222 11.3367 13.111 11.3367H10.8691C10.8075 11.3367 10.7763 11.3201 10.7389 11.272C10.6873 11.2056 10.6381 11.0823 10.6347 10.9283C10.6313 10.7736 10.6752 10.6644 10.7141 10.6133C10.7349 10.5861 10.7628 10.5544 10.8691 10.5544H12.1302H13.3913C13.8208 10.5544 14.1691 10.2061 14.1691 9.77659C14.1691 9.34703 13.8208 8.99881 13.3913 8.99881H12.8765V8.47404Z"
                        fill="#307C5A"
                      />
                    </svg>
                    {project?.has_budget === 1
                      ? project?.budget
                      : `${project?.min_budget} - ${project?.max_budget}`}
                  </h5>
                  <p>Budget</p>
                </div>
              </div>

              {/* COVER IMAGE */}
              {/* <div className="cover">
                <img
                  src={process.env.REACT_APP_IMAGE_API_PREFIX + `${project?.cover_image}`}
                  alt="coverImage"
                />
              </div> */}

              {/* DESCRIPTION */}
              <div className="description">
                <h5>Project Description</h5>
                <p>{project?.description}</p>
              </div>
              {/* MILESTONE */}
              {project?.project_milestones?.length > 0 ? (
                <div className="milestone">
                  <h5>Project Milestones</h5>
                  <div className="milestone-area">
                    {project?.project_milestones.length > 0 &&
                      project?.project_milestones.map(milestone => {
                        return (
                          <div className="milestone-area--item" key={milestone.id}>
                            <div className="milestone-area--item--content">
                              <h1>{`Milestone${milestone.id}`}</h1>
                              <div className="milestone-area--item--content--box">
                                <h6>{milestone.milestone_name}</h6>
                                <p className="milestone-area--item--content--box--desc">
                                  <span>
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M2.55556 8C2.55556 4.99312 4.99312 2.55556 8 2.55556C11.0069 2.55556 13.4444 4.99312 13.4444 8C13.4444 11.0069 11.0069 13.4444 8 13.4444C4.99312 13.4444 2.55556 11.0069 2.55556 8ZM8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1ZM8.87648 4.47404C8.87648 4.04449 8.52826 3.69627 8.0987 3.69627C7.66915 3.69627 7.32092 4.04449 7.32092 4.47404V4.99881H6.8691C6.27478 4.99881 5.79027 5.25927 5.47691 5.67043C5.18175 6.05773 5.07 6.533 5.07954 6.96281C5.0891 7.39327 5.22156 7.85444 5.51053 8.22637C5.81371 8.61661 6.28199 8.89227 6.8691 8.89227H9.11104C9.34059 8.89227 9.41841 8.96526 9.4426 8.99282C9.47723 9.03229 9.51093 9.10779 9.50175 9.22011C9.49262 9.33193 9.44219 9.44431 9.35709 9.526C9.28068 9.59936 9.14902 9.67462 8.9188 9.67462H6.02837C5.59882 9.67462 5.25059 10.0228 5.25059 10.4524C5.25059 10.8819 5.59882 11.2302 6.02837 11.2302H7.32092V11.6217C7.32092 12.0513 7.66915 12.3995 8.0987 12.3995C8.52826 12.3995 8.87648 12.0513 8.87648 11.6217V11.2302H8.9188C10.1941 11.2302 10.9738 10.306 11.0521 9.34677C11.0907 8.87462 10.9618 8.36565 10.6118 7.96675C10.2512 7.55596 9.72223 7.33671 9.11104 7.33671H6.8691C6.80752 7.33671 6.77631 7.32014 6.73892 7.27201C6.68732 7.20559 6.63814 7.08229 6.63472 6.92827C6.63128 6.7736 6.67521 6.6644 6.71413 6.61333C6.73485 6.58614 6.76281 6.55436 6.8691 6.55436H8.13019H9.39128C9.82084 6.55436 10.1691 6.20614 10.1691 5.77659C10.1691 5.34703 9.82084 4.99881 9.39128 4.99881H8.87648V4.47404Z"
                                        fill="#307C5A"
                                      />
                                    </svg>
                                  </span>
                                  {milestone.milestone_amount}
                                </p>
                                <h2>Description</h2>
                                <p className="milestone-area--item--content--box--descs">
                                  {milestone.milestone_description}
                                </p>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
              ) : null}
              {/* SKILLS */}
              {project?.project_skills?.length > 0 ? (
                <div className="skills">
                  <h5>Required Skills</h5>
                  <div className="skills-area">
                    {project?.project_skills.length > 0 &&
                      project?.project_skills.map(skill => {
                        return (
                          <div className="skills-area--item" key={skill.id}>
                            {skill.skill}
                          </div>
                        )
                      })}
                  </div>
                </div>
              ) : null}

              {/* KEYWORDS */}
              {project?.project_keywords?.length > 0 ? (
                <div className="keywords">
                  <h5>Keywords</h5>
                  <div className="keywords-area">
                    {project?.project_keywords.length > 0 &&
                      project?.project_keywords.map(keyword => {
                        return (
                          <div className="keywords-area--item" key={keyword.id}>
                            {keyword.keyword}
                          </div>
                        )
                      })}
                  </div>
                </div>
              ) : null}

              {/* ATTACHMENTS */}
              {project?.project_attachments?.length > 0 ? (
                <div className="attachments">
                  <h5>Attached Files</h5>
                  <div className="attachments-area">
                    {project?.project_attachments.length > 0 &&
                      project?.project_attachments.map(attach => {
                        return (
                          <div className="attachments-area--item" key={attach.id}>
                            <svg
                              width="28"
                              height="28"
                              viewBox="0 0 28 28"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g clipPath="url(#clip0_10110_48707)">
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M3.33594 0C2.78365 0 2.33594 0.447715 2.33594 1V27C2.33594 27.5523 2.78365 28 3.33594 28H24.6693C25.2216 28 25.6693 27.5523 25.6693 27V4.66667L21.0026 0H3.33594Z"
                                  fill="#E9F0FA"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M21.0039 0V4.66667H25.6706L21.0039 0Z"
                                  fill="#C2CDDE"
                                />
                              </g>
                              <rect
                                x="1.16797"
                                y="11.6641"
                                width="25.6667"
                                height="11.6667"
                                rx="1"
                                fill="#3E76CD"
                              />
                              <path
                                d="M6.43714 20.5V14.6818H10.1644V15.5653H7.49112V17.1449H9.90874V18.0284H7.49112V20.5H6.43714ZM12.1786 14.6818V20.5H11.1246V14.6818H12.1786ZM13.32 20.5V14.6818H14.3739V19.6165H16.9364V20.5H13.32ZM17.8512 20.5V14.6818H21.6353V15.5653H18.9052V17.1449H21.4393V18.0284H18.9052V19.6165H21.658V20.5H17.8512Z"
                                fill="white"
                              />
                              <defs>
                                <clipPath id="clip0_10110_48707">
                                  <rect
                                    width="23.3333"
                                    height="28"
                                    fill="white"
                                    transform="translate(2.33594)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            <div className="details">
                              <h6>
                                <FileName mediaString={attach.filename} />
                                {/* <getAttachFilename ={attach.filename}/> */}
                              </h6>
                            </div>
                            <button type="button">
                              <a target="_blank" href={attach.filename} rel="noreferrer">
                                <svg
                                  width="17"
                                  height="17"
                                  viewBox="0 0 17 17"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M2.4987 10.1348C2.86689 10.1348 3.16536 10.4332 3.16536 10.8014V13.4681C3.16536 13.6449 3.2356 13.8145 3.36063 13.9395C3.48565 14.0645 3.65522 14.1348 3.83203 14.1348H13.1654C13.3422 14.1348 13.5117 14.0645 13.6368 13.9395C13.7618 13.8145 13.832 13.6449 13.832 13.4681V10.8014C13.832 10.4332 14.1305 10.1348 14.4987 10.1348C14.8669 10.1348 15.1654 10.4332 15.1654 10.8014V13.4681C15.1654 13.9985 14.9546 14.5072 14.5796 14.8823C14.2045 15.2574 13.6958 15.4681 13.1654 15.4681H3.83203C3.3016 15.4681 2.79289 15.2574 2.41782 14.8823C2.04274 14.5072 1.83203 13.9985 1.83203 13.4681V10.8014C1.83203 10.4332 2.13051 10.1348 2.4987 10.1348Z"
                                    fill="#565656"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M4.69526 6.99604C4.95561 6.73569 5.37772 6.73569 5.63807 6.99604L8.5 9.85797L11.3619 6.99604C11.6223 6.73569 12.0444 6.73569 12.3047 6.99604C12.5651 7.25639 12.5651 7.6785 12.3047 7.93885L8.9714 11.2722C8.71106 11.5325 8.28894 11.5325 8.0286 11.2722L4.69526 7.93885C4.43491 7.6785 4.43491 7.25639 4.69526 6.99604Z"
                                    fill="#565656"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.4987 2.13477C8.86689 2.13477 9.16536 2.43324 9.16536 2.80143V10.8014C9.16536 11.1696 8.86689 11.4681 8.4987 11.4681C8.13051 11.4681 7.83203 11.1696 7.83203 10.8014V2.80143C7.83203 2.43324 8.13051 2.13477 8.4987 2.13477Z"
                                    fill="#565656"
                                  />
                                </svg>
                              </a>
                            </button>
                          </div>
                        )
                      })}
                  </div>
                </div>
              ) : null}

              {/* FAQ */}
              {project?.project_faqs?.length > 0 ? (
                <div className="faq">
                  <h5>Frequently Asked Questions</h5>
                  <div className="faq-area">
                    {project?.project_faqs.length > 0 &&
                      project?.project_faqs.map(faq => {
                        return (
                          <div className="faq-area--item" key={faq.id}>
                            <div className="question">
                              <h6>Q</h6>
                              <p>{faq.question}</p>
                            </div>
                            <div className="answer">
                              <h6>A</h6>
                              <p>{faq.answer}</p>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                </div>
              ) : null}
            </div>
          </div>

          {/* BUYER GRID */}
          <div className="project-body--buyer">
            <div
              style={{
                padding: " 10px",
                margin: "16px",
                width: "100%",
              }}
            >
              <h4>Buyer</h4>
              <div className="buyer">
                <div className="buyer-area">
                  <div className="buyer-area-image">
                    <img
                      src={
                        process.env.REACT_APP_IMAGE_API_PREFIX + `${project?.member?.profile_image}`
                      }
                      alt="buyer-image"
                    />
                  </div>
                  <div className="buyer-area-detail">
                    <h6>{project?.member?.fullname}</h6>
                    <p>{project?.member?.profession}</p>
                  </div>
                </div>
                {/* <div className="buyer-rating">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g id="Icon pack Variants">
                    <g id="Star 3 (Stroke)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.61635 4.79499C10.3666 2.40166 13.6334 2.40168 14.3836 4.79499L15.2724 7.62998C15.3203 7.78288 15.4578 7.8864 15.6129 7.8864H18.4889C20.9168 7.8864 21.9263 11.1066 19.9621 12.5857L17.6353 14.3379C17.5098 14.4324 17.4573 14.5999 17.5053 14.7528L18.394 17.5877C19.1443 19.9811 16.5014 21.9713 14.5372 20.4921L12.2105 18.74C12.085 18.6455 11.915 18.6455 11.7895 18.74L9.46283 20.4921C7.49859 21.9713 4.85574 19.9811 5.60601 17.5877L6.49473 14.7528C6.54267 14.5999 6.49015 14.4324 6.36466 14.3379L4.03794 12.5857C2.07371 11.1066 3.0832 7.8864 5.51112 7.8864H8.3871C8.54222 7.8864 8.67969 7.78288 8.72762 7.62997L9.61635 4.79499ZM12.3405 5.48305C12.2333 5.14115 11.7667 5.14115 11.6595 5.48305L10.7708 8.31804C10.4352 9.38836 9.47291 10.113 8.3871 10.113H5.51112C5.16427 10.113 5.02007 10.5731 5.30067 10.7844L7.62739 12.5365C8.50582 13.198 8.87339 14.3705 8.53786 15.4408L7.64913 18.2758C7.54195 18.6177 7.91951 18.902 8.2001 18.6907L10.5268 16.9386C11.4053 16.2771 12.5947 16.2771 13.4732 16.9386L15.7999 18.6907C16.0805 18.902 16.458 18.6177 16.3509 18.2758L15.4621 15.4408C15.1266 14.3705 15.4942 13.198 16.3726 12.5365L18.6993 10.7844C18.9799 10.5731 18.8357 10.113 18.4889 10.113H15.6129C14.5271 10.113 13.5648 9.38837 13.2292 8.31804L12.3405 5.48305Z"
                        fill="#EFA148"
                      />
                      <path
                        d="M11.6595 5.48305C11.7667 5.14115 12.2333 5.14115 12.3405 5.48305L13.2292 8.31804C13.5648 9.38837 14.5271 10.113 15.6129 10.113H18.4889C18.8357 10.113 18.9799 10.5731 18.6993 10.7844L16.3726 12.5365C15.4942 13.198 15.1266 14.3705 15.4621 15.4408L16.3509 18.2758C16.458 18.6177 16.0805 18.902 15.7999 18.6907L13.4732 16.9386C12.5947 16.2771 11.4053 16.2771 10.5268 16.9386L8.2001 18.6907C7.91951 18.902 7.54195 18.6177 7.64913 18.2758L8.53786 15.4408C8.87339 14.3705 8.50582 13.198 7.62739 12.5365L5.30067 10.7844C5.02007 10.5731 5.16427 10.113 5.51112 10.113H8.3871C9.47291 10.113 10.4352 9.38836 10.7708 8.31804L11.6595 5.48305Z"
                        fill="#EFA148"
                      />
                    </g>
                  </g>
                </svg>
                4.0
              </div> */}
              </div>
              <div className="conditions">
                <div className="conditions-location">
                  <svg
                    width="12"
                    height="15"
                    viewBox="0 0 12 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6 1.93025C4.96641 1.93025 3.96112 2.37745 3.20955 3.19707C2.45604 4.01881 2.02308 5.14583 2.02308 6.33284C2.02308 6.72476 2.14974 7.22764 2.40497 7.82097C2.65655 8.4058 3.012 9.03063 3.41897 9.65271C4.23301 10.897 5.21387 12.071 5.86331 12.8052C5.90543 12.8528 5.95446 12.8705 6 12.8705C6.04554 12.8705 6.09457 12.8528 6.13669 12.8052C6.78613 12.071 7.76699 10.897 8.58103 9.65271C8.988 9.03063 9.34345 8.4058 9.59503 7.82097C9.85026 7.22764 9.97692 6.72476 9.97692 6.33284C9.97692 5.14583 9.54396 4.01881 8.79045 3.19707C8.03888 2.37745 7.03359 1.93025 6 1.93025ZM6 4.48001C4.8317 4.48001 3.88461 5.43132 3.88461 6.60482C3.88461 7.77832 4.8317 8.72962 6 8.72962C7.16829 8.72962 8.11538 7.77832 8.11538 6.60482C8.11538 5.43132 7.16829 4.48001 6 4.48001Z"
                      fill="#ED2121"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M6 1.93025C4.96641 1.93025 3.96112 2.37745 3.20955 3.19707C2.45604 4.01881 2.02308 5.14583 2.02308 6.33284C2.02308 6.72476 2.14974 7.22764 2.40497 7.82097C2.65655 8.4058 3.012 9.03063 3.41897 9.65271C4.23301 10.897 5.21387 12.071 5.86331 12.8052C5.90543 12.8528 5.95446 12.8705 6 12.8705C6.04554 12.8705 6.09457 12.8528 6.13669 12.8052C6.78613 12.071 7.76699 10.897 8.58103 9.65271C8.988 9.03063 9.34345 8.4058 9.59503 7.82097C9.85026 7.22764 9.97692 6.72476 9.97692 6.33284C9.97692 5.14583 9.54396 4.01881 8.79045 3.19707C8.03888 2.37745 7.03359 1.93025 6 1.93025ZM2.08926 2.16063C3.11496 1.04206 4.52016 0.400391 6 0.400391C7.47984 0.400391 8.88504 1.04206 9.91074 2.16063C10.9345 3.2771 11.5 4.77883 11.5 6.33284C11.5 7.02038 11.2877 7.74316 10.9932 8.42778C10.695 9.12091 10.2899 9.82631 9.85388 10.4929C8.98183 11.8258 7.94646 13.0626 7.27527 13.8213C6.5923 14.5934 5.4077 14.5934 4.72473 13.8213C4.05354 13.0626 3.01817 11.8258 2.14612 10.4929C1.71005 9.82632 1.305 9.12091 1.00683 8.42778C0.712322 7.74316 0.5 7.02038 0.5 6.33284C0.5 4.77883 1.06549 3.2771 2.08926 2.16063Z"
                      fill="#ED2121"
                    />
                  </svg>
                  {project?.member?.country?.name}
                  {/* <svg
                  width="28"
                  height="21"
                  viewBox="0 0 28 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.3333 0.400391H2.66667C1.19391 0.400391 0 1.5943 0 3.06706V17.7337C0 19.2065 1.19391 20.4004 2.66667 20.4004H25.3333C26.8061 20.4004 28 19.2065 28 17.7337V3.06706C28 1.5943 26.8061 0.400391 25.3333 0.400391Z"
                    fill="#F93939"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14 13.7337C15.84 13.7337 17.3333 12.2404 17.3333 10.4004C17.3333 8.56039 15.84 7.06706 14 7.06706C12.16 7.06706 10.6667 8.56039 10.6667 10.4004C10.6667 12.2404 12.16 13.7337 14 13.7337ZM14 12.4004C15.104 12.4004 16 11.2071 16 9.73372C16 8.26039 15.104 7.06706 14 7.06706C12.896 7.06706 12 8.26039 12 9.73372C12 11.2071 12.896 12.4004 14 12.4004ZM14 11.0671C14.368 11.0671 14.6667 10.4697 14.6667 9.73372C14.6667 8.99772 14.368 8.40039 14 8.40039C13.632 8.40039 13.3333 8.99772 13.3333 9.73372C13.3333 10.4697 13.632 11.0671 14 11.0671Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.6667 0.400391H28V20.4004H18.6667V0.400391Z"
                    fill="#249F58"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 0.400391H9.33333V20.4004H0V0.400391Z"
                    fill="#151515"
                  />
                </svg> */}
                </div>
                <div className="conditions-posted">{project?.member?.jobs_posted} posted</div>
                <div className="conditions-spent">$ {project?.member?.amount_spent}</div>
                <div className="conditions-duration">{project?.member?.joined_at}</div>
              </div>
              <div className="about">
                <h6>About</h6>
                <p>{project?.member?.about}</p>
              </div>
              {/* <button>Contact {project?.member?.fullname}</button> */}
            </div>
            <div className="acceptedbid">
              <div className="acceptedbid_wrapper">
                <div className="header">
                  <h1>Accepted Bid</h1>
                </div>
                <div>
                  <BiddingDisplay project={project} />
                </div>
              </div>
            </div>
            <div className="acceptedbid" style={{marginTop:"16px"}}>
              <div className="acceptedbid_wrapper">
                <div className="header">
                  <h1>Pending Payment</h1>
                </div>
                <div>
                 <PendingTransaction projectId={project.id}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RejectProjectModal
        isOpen={isOpen}
        toggle={toggle}
        title={project?.title}
        id={project?.id}
      ></RejectProjectModal>
    </Fragment>
  )
};

export default ViewProject;
